<p>shared-module works!</p>
